<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="triggerOptions"
                display-unit="s"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'dropdown-trigger';
const DEFAULT_VALUE = 'click';

export default {
    name: 'control-nav-dropdown-trigger',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Dropdown Trigger',
            value: 'click',

            triggerOptions: [
                { text: 'On Click', value: 'click' },
                { text: 'On Hover', value: 'hover' },
            ],
        };
    },

    methods: {
        onInput(value) {
            this.value = value;
            this.setData(value);
            this.onOptionChange(value);
        },

        setData(value) {
            this.selectedElements.forEach((elem) => {
                elem.setElementData(CUSTOM_ATTR_NAME, value);
            });
        },

        onSelectedElement() {
            const value = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
            this.value = value || DEFAULT_VALUE;
        },
    },
};
</script>
